import { SigningModeType } from '../../shared/constants/signingModeType';
import { SIGNING_FLOW_TYPE_MAP } from '../../shared/constants/signingFlowType';

interface Props {
    mode: SigningModeType;
    isSocialFlow: boolean;
}

export const getSigningFlowType = ({ mode, isSocialFlow }: Props) => {
    if (mode === 'sign_up') {
        return isSocialFlow ? SIGNING_FLOW_TYPE_MAP.socialSignUp : SIGNING_FLOW_TYPE_MAP.signUp;
    }

    return isSocialFlow ? SIGNING_FLOW_TYPE_MAP.social : SIGNING_FLOW_TYPE_MAP.signIn;
};
